function formatDateYYMMDD(date) {
  return padStr(date.getFullYear()).substr(2) +
         padStr(1 + date.getMonth()) +
         padStr(date.getDate());
}

function padStr(i) {
  return (i < 10) ? "0" + i : "" + i;
}

module.exports = formatDateYYMMDD;
